import { useEffect, useState } from "react";
import { Box, Button, IconButton, Typography } from "@material-ui/core";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import useMarketingStyles from "../styles";

const { primary } = themeColorsDesingSystem;

export default function HeroCarousel({ campaigns, onViewCampaign }) {
  const classes = useMarketingStyles();
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || campaigns.length <= 1) return undefined;

    const timer = setInterval(() => {
      setIndex((current) => (current === campaigns.length - 1 ? 0 : current + 1));
    }, 6000);

    return () => clearInterval(timer);
  }, [paused, campaigns.length]);

  if (!campaigns.length) return null;

  return (
    <Box
      className={classes.heroRoot}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {campaigns.map((slide, slideIndex) => (
        <Box
          key={slide.id}
          className={`${classes.heroSlide} ${slideIndex === index ? classes.heroSlideActive : ""}`}
        >
          <img src={slide.imagem} alt={slide.titulo} className={classes.heroImage} />
          <Box className={classes.heroOverlay}>
            <Typography variant="caption" style={{ color: "rgba(255,255,255,0.9)", marginBottom: 4 }}>
              {slide.subtitulo}
            </Typography>
            <Typography
              variant="h2"
              style={{ color: "#fff", fontWeight: 700, marginBottom: 20, lineHeight: 1.2 }}
            >
              {slide.titulo}
            </Typography>
            <Button
              variant="contained"
              style={{
                backgroundColor: "#fff",
                color: primary.main,
                width: "fit-content",
                borderRadius: 8,
                fontWeight: 600,
                boxShadow: "none",
              }}
              onClick={() => onViewCampaign(slide.campanhaId)}
            >
              Ver campanha
            </Button>
          </Box>
        </Box>
      ))}

      <IconButton
        onClick={() => setIndex((current) => (current === 0 ? campaigns.length - 1 : current - 1))}
        className={classes.heroNavBtn}
        style={{ left: 16 }}
        aria-label="Anterior"
        size="small"
      >
        <ChevronLeftIcon />
      </IconButton>
      <IconButton
        onClick={() => setIndex((current) => (current === campaigns.length - 1 ? 0 : current + 1))}
        className={classes.heroNavBtn}
        style={{ right: 16 }}
        aria-label="Próximo"
        size="small"
      >
        <ChevronRightIcon />
      </IconButton>

      <Box className={classes.heroDots}>
        {campaigns.map((slide, slideIndex) => (
          <Box
            key={slide.id}
            onClick={() => setIndex(slideIndex)}
            className={classes.heroDot}
            style={{
              backgroundColor: slideIndex === index ? "#fff" : "rgba(255,255,255,0.45)",
              transform: slideIndex === index ? "scale(1.2)" : "scale(1)",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
